import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, LicenseService, LinksService } from '@isophi/core-legacy';
import { map } from 'rxjs/operators';

import { RouterLinkFactory } from '../../../core/router/router-link.factory';
import { UserService } from '../../../core/services/user.service';
import { SwitchToDemoKindergartenService } from '../../services/switch-to-demo-kindergarten.service';

@Component({
  selector: 'app-home-hint',
  templateUrl: './home-hint.component.html',
  styleUrls: ['./home-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeHintComponent {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  protected readonly links = inject(RouterLinkFactory);
  protected readonly activatedRoute = inject(ActivatedRoute);
  private readonly switchDemoKindergartenService = inject(SwitchToDemoKindergartenService);
  private readonly licenceService = inject(LicenseService);
  private readonly linksService = inject(LinksService);

  protected readonly isManager = this.authService.loggedUser?.teacher?.isManager() || false;

  protected readonly tAppUrl = this.linksService.getTeacherAppUrl();
  protected readonly papAppUrl = this.linksService.getPapAppUrl();

  @Input() isFirstTime = false;

  readonly showDemoSwitch$ = this.licenceService.canSeeDemoKindergarten.pipe(
    map((hasShowcase) => !this.userService.loggedKindergarten?.isDemo && hasShowcase)
  );

  readonly showTeacherApp$ = this.licenceService.canSeeTeacherApp;
  readonly showPap$ = this.licenceService.canSeePap;
  readonly showChildPortfolio$ = this.licenceService.canSeeChildPortfolio;
  readonly showManagement$ = this.licenceService.canSeeManagement;
  readonly hasTrial$ = this.licenceService.hasAnyTrial;

  switchToDemoKindergarten() {
    this.switchDemoKindergartenService.switch();
  }
}
